import { Boolean, Null, Record, String } from 'runtypes';

export const TaskListExtrasRunType = Record({
	userHasWriteAccessToTheTask: Boolean,
});

export const GroupedStatusRunType = Record({
	calculated: String.Or(Null),
	userList: String.Or(Null),
});
